import React from "react";
import CodeBlock from "../../components/CodeBlock";
import "./styles.scss";
import { useLanguage } from "../../contexts/LanguageContext";

const Errors: React.FC = () => {
  const { selectedLanguage, getCodeSnippet } = useLanguage();
  const code = getCodeSnippet("error", "index");

  return (
    <>
      <div className="px-0 py-4 md:px-4">
        <div className="main-div">
          <p className="text-6xl m-0 mb-4">Errors</p>
          <p className="m-0 text-xl mb-4">
            When integrating with our API, errors can occur due to various
            reasons, such as invalid requests, authentication failures, or
            exceeding rate limits. This page provides a comprehensive guide to
            understanding and handling errors returned by our API. By following
            the information outlined here, developers can efficiently debug and
            resolve issues to ensure a smooth integration process. We categorize
            errors into HTTP status codes, internal error codes, and common
            scenarios to make troubleshooting straightforward. Additionally,
            examples of error responses and suggested solutions are provided for
            clarity.
          </p>
          <CodeBlock code={code} language={selectedLanguage} />
        </div>
      </div>
    </>
  );
};

export default Errors;
